export const DELAY_MIN = 5;
export const DELAY_MAX = 20;
